import React, {useEffect, useState} from "react";
import {
    IonContent,
    IonIcon,
    IonButton,
    IonModal,
    IonButtons,
    IonHeader,
    IonToolbar, IonFooter
} from "@ionic/react";
import {arrowBack, funnel, funnelOutline} from "ionicons/icons";
import FilterSheetModal from "./FilterSheetModal";
import JobCard from "./JobCard";
import useStore from "../zustand/useStore";
import {actionToGetJobPostingByFilter} from "../apiHelpers/CommonAction";
import {FacebookLoader} from "./Loader/FacebookLoader";
import NoDataFoundOrSelectedDiv from "./NoDataFoundOrSelectedDiv";
import JobProfileCard from "./JobProfileCard";

export default function JobPortalCandidateRoleComponentMobile({isOpen,onDidDismiss,myJobPostsData,selectedJobListUserType = 1}) {
    const {userAuthDetail,jobPostingState,selectedWorkTypes,selectedDepartments,selectedState,experience,salaryRange} = useStore();
    const {userInfo} = userAuthDetail;
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const {setIsJobDetailOpen,setJobDetailsData,setIsOpenCandidatesDeservingModel,setDeservingCandidatesProfileData} = useStore();
    const {loading,jobPostings,totalCount} = jobPostingState;
    const isFetchingRef = React.useRef(false); // prevent multiple calls
    const observerRef = React.useRef(null);
    const [filterTypeSelection,setFilterTypeSelection] = useState('Work mode');

    const callFunctionToFilterJobPosting = async (isLoad = true)=>{
        if (isFetchingRef.current) return;
            isFetchingRef.current = true;
        const payload = {};
        if (selectedWorkTypes.length > 0) payload.work_type = selectedWorkTypes;
        if (selectedDepartments.length > 0) payload.selectedDepartments = selectedDepartments;
        if (selectedState.length > 0) payload.selectedState = selectedState;
        if (experience > 0) payload.experience = experience;
        if (salaryRange > 0) payload.salary = salaryRange;
        payload.me_mode = !!myJobPostsData;
        payload.user_type = selectedJobListUserType;
        await actionToGetJobPostingByFilter(isLoad,payload);
        isFetchingRef.current = false;
    }

    const callFunctionToSetIsFilterOpen = (type)=>{
        setFilterTypeSelection(type);
        setIsFilterOpen(true);
    }

    useEffect(() => {
        if(isOpen) {
            callFunctionToFilterJobPosting();
        }
    },[isOpen])

    const openJobDetailPanel = (jobDetail)=>{
        setJobDetailsData(jobDetail);
        setIsJobDetailOpen(true);
    }

    const lastJobElementRef = React.useCallback(
        (node) => {
            if (observerRef.current) observerRef.current.disconnect();

            observerRef.current = new IntersectionObserver((entries) => {
                if (entries[0].isIntersecting && jobPostings?.length < totalCount) {
                    callFunctionToFilterJobPosting(false); // Load next page
                }
            });

            if (node) observerRef.current.observe(node);
        },
        [totalCount, callFunctionToFilterJobPosting,jobPostings]
    );

    const showApplyButton =
        selectedWorkTypes.length > 0 ||
        selectedDepartments.length > 0 ||
        selectedState.length > 0 ||
        experience > 0 ||
        salaryRange > 0;

    const openJobCandidateProfileDetail = (jobProfile)=>{
        setIsOpenCandidatesDeservingModel(true);
        setDeservingCandidatesProfileData({...jobProfile});
    }

    const panelSubHeader = ()=>{
        return (
            <div className={`filter-header-wrapper`}>
                <div className={`filter-header ${userInfo?.job_portal_role === 1 ? 'assignment_filter_wraper' : ''}`}>
                    <IonButton fill="clear" size="small" onClick={() => callFunctionToSetIsFilterOpen('Work mode')}
                               className={`filter-btn ${showApplyButton ? 'active' : ''}`}>
                        {(showApplyButton) ?
                            <IonIcon icon={funnel} slot="start"/>
                            :
                            <IonIcon icon={funnelOutline} slot="start"/>
                        }
                    </IonButton>
                    <div className="tags">
                        <span className={`tag ${showApplyButton && filterTypeSelection === 'Work mode' ? 'active' : ''}`}
                              onClick={() => callFunctionToSetIsFilterOpen('Work mode')}>Work mode</span>
                        <span className={`tag ${showApplyButton && filterTypeSelection === 'Experience' ? 'active' : ''}`}
                              onClick={() => callFunctionToSetIsFilterOpen('Experience')}>Experience</span>
                        <span className={`tag ${showApplyButton && filterTypeSelection === 'Location' ? 'active' : ''}`}
                              onClick={() => callFunctionToSetIsFilterOpen('Location')}>Location</span>
                        <span className={`tag ${showApplyButton && filterTypeSelection === 'Salary' ? 'active' : ''}`}
                              onClick={() => callFunctionToSetIsFilterOpen('Salary')}>Salary</span>
                        <span className={`tag ${showApplyButton && filterTypeSelection === 'Department' ? 'active' : ''}`}
                              onClick={() => callFunctionToSetIsFilterOpen('Department')}>Department</span>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <IonModal
            isOpen={isOpen}
            onDidDismiss={onDidDismiss}
            initialBreakpoint={1}
            breakpoints={[0, 1]}
            handleBehavior="cycle"
        >
            <IonHeader className="job_detail_sheet_header sheet_modal_header">
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonButton className={"close_job_post_button"} onClick={onDidDismiss}>
                            <IonIcon icon={arrowBack}/>
                        </IonButton>
                    </IonButtons>
                    <div className="job_detail_sheet_header_text">
                        <div className="job-basic-info-image">
                            <span className="job-basic-info-text">
                                {myJobPostsData ? 'My' : ''} Job Posts List
                            </span>
                        </div>
                    </div>
                </IonToolbar>
                <IonToolbar>
                    {panelSubHeader()}
                </IonToolbar>
            </IonHeader>
            <IonContent className="mobile-job-list-page page-content">
                {(loading) ?
                    <div className="job-list">
                        <div className="job-card">
                            <FacebookLoader type={"facebookStyle"} item={1}/>
                        </div>
                        <div className="job-card">
                            <FacebookLoader type={"facebookStyle"} item={1}/>
                        </div>
                        <div className="job-card">
                            <FacebookLoader type={"facebookStyle"} item={1}/>
                        </div>
                    </div>
                    :
                    (jobPostings && jobPostings?.length > 0) ?
                        <div className="job-list">
                            {jobPostings.map((job, index) => {
                                if (index === jobPostings.length - 1) {
                                    return (
                                        <div ref={lastJobElementRef} key={job.id}>
                                            {(selectedJobListUserType === 2) ?
                                                <JobCard job={job} handleJobItemClick={openJobDetailPanel}/>
                                                :
                                                <JobProfileCard openJobCandidateProfileDetail={openJobCandidateProfileDetail} jobProfileData={job}/>
                                            }
                                        </div>
                                    );
                                }
                                if(selectedJobListUserType === 2){
                                    return (
                                        <JobProfileCard openJobCandidateProfileDetail={openJobCandidateProfileDetail} key={job.id} jobProfileData={job}/>
                                    );
                                }else{
                                    return (
                                        <JobCard key={job.id} job={job} handleJobItemClick={openJobDetailPanel}/>
                                    );
                                }
                            })}
                        </div>
                        :
                        <div className="job-list">
                            <NoDataFoundOrSelectedDiv/>
                        </div>
                }
            </IonContent>
            <IonFooter className={"blank_footer_bar"}>
                <IonToolbar>

                </IonToolbar>
            </IonFooter>

            {(isFilterOpen) ?
            <FilterSheetModal
                isOpen={isFilterOpen}
                selectedJobListUserType={selectedJobListUserType}
                myJobPostsData={myJobPostsData}
                filterTypeSelection={filterTypeSelection}
                setFilterTypeSelection={setFilterTypeSelection}
                onDidDismiss={() => setIsFilterOpen(false)}
            />:''
            }
        </IonModal>
    );
}
